import { useState, useCallback, ChangeEvent, useEffect } from 'react';
import { useTellerSession } from '~/common/hooks/use-auth/use-teller-session';
import type { StoryOverview } from '~/common/types/story-overview';
import { routes } from '~/utils/routes';
import { useDisclosure } from '@app/_hooks/use-disclosure';
import { getIsAccepted } from '@app/_hooks/use-is-accepted-sensitive';
import { useUpdateAcceptedSensitive } from '@app/_hooks/use-update-show-sensitive';
import { navigate } from '@app/actions';

export const useLocalHooks = (
  storyOverview: StoryOverview,
  isShowSensitiveParam: boolean,
  referer?: string
) => {
  const { session } = useTellerSession();
  const [isShowAlwaysChecked, setShowAlwaysChecked] = useState(true);
  const { accept } = useUpdateAcceptedSensitive();

  const sensitiveStoryModal = useDisclosure();

  useEffect(() => {
    if (
      (storyOverview.isSensitive || isShowSensitiveParam) &&
      !getIsAccepted()
    ) {
      sensitiveStoryModal.onOpen();
    }
  }, [isShowSensitiveParam, sensitiveStoryModal, storyOverview.isSensitive]);

  const changeAlwaysShowSetting = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setShowAlwaysChecked(e.target.checked);
    },
    []
  );

  const onClickCancel = useCallback(() => {
    if (typeof window === 'undefined') return;

    if (!referer || new URL(window.location.href).pathname === referer) {
      navigate(routes.home.url());
    } else {
      try {
        navigate(referer);
      } catch {
        navigate(routes.home.url());
      }
    }
    sensitiveStoryModal.onClose();
  }, [referer, sensitiveStoryModal]);

  const onClickOk = useCallback(
    async (showAlways: boolean) => {
      await accept(showAlways);
      // トップページに遷移させる
      sensitiveStoryModal.onClose();
    },
    [accept, sensitiveStoryModal]
  );

  return {
    isShowAlwaysChecked,
    changeAlwaysShowSetting,
    session,
    sensitiveStoryModal,
    onClickCancel,
    onClickOk,
  };
};
